import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {AuthService} from "../services/auth/auth.service";
import {ApiResponse} from "../api/api-response";
import {Router} from "@angular/router";
import {SnackbarService} from "../services/snackbar/snackbar.service";
import {LoaderService} from "../services/loader/loader.service";
import {IGNORE_BAD_REQUEST} from '../services/api-client/api-client.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
    private snackbar: SnackbarService,
    private loader: LoaderService
  ) {
  }

  intercept(request: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {
    return handler.handle(request).pipe(
      catchError((response) => this.errorHandler(request, response))
    );
  }

  errorHandler(request: HttpRequest<any>, response: HttpErrorResponse) {
    const ignoreBadRequest = request.context.has(IGNORE_BAD_REQUEST) ? request.context.get(IGNORE_BAD_REQUEST) : false;

    let message = response.error ? response.error.message ?? response.message : response.message;
    switch (response.status) {
      case 401:
        if (!this.router.url.startsWith('/login')) {
          this.authService.logout();
        }
        break;
      case 403:
        this.snackbar.error('Access denied.');
        this.router.navigateByUrl('/').then();
        break;
      default:
        if (!ignoreBadRequest && response.status >= 400) {
          this.snackbar.error(message, response.error.data ?? null);
        }
        break;
    }

    const error = new ApiResponse(
        response.status,
        false,
        message,
        response.error ? response.error.data ?? null : null,
        response.error?.errors ?? null
      )
    ;

    console.error(error);

    this.loader.stopLoading()

    return throwError(() => error);
  }
}
